import * as yup from 'yup';

import loadash from 'lodash';

yup.addMethod(yup.array, 'uniquePrimaryKey', function (message, path) {
	return this.test('uniquePrimaryKey', message, function (list) {
		let length = 0;
		list.forEach((item) => {
			if (item.isPrimary) {
				length++;
			}
		});

		if (length === 1) {
			return true;
		}

		return this.createError({ message });
	});
});

const assetScheme = yup.object().shape({
	type: yup.string().required('Invalid type'),
});

const schema = yup.object().shape({
	name: yup.string().required('Please type template name'),
	assets: yup
		.array()
		.of(assetScheme)
		.uniquePrimaryKey('Atleast & At most one asset should have isPrimary key')
		.min(1, 'Atleast one asset should be added'),
	deviceType: yup.string().required('Please selected device type'),
});

export const validateSchema = async (template) => {
	return new Promise((resolve, reject) => {
		(async () => {
			try {
				const result = await schema.validate(template, { abortEarly: false });
				resolve(result);
			} catch (err) {
				const errorObj = {};
				err.inner.forEach((param) => {
					loadash.set(errorObj, param.path, param.message);
				});

				reject(errorObj);
			}
		})();
	});
};
